// Strip null/empty optional address fields from a farm location address in-place.
// Why: when an offer's location is loaded via GraphQL, missing optional scalars
// come back as `null` (not `undefined`). The form state mirrors that, so when
// we send the recalculate input back to the backend we re-send `county: null`
// — even though the location may have had a county on the saved record. The
// backend's `createDefaultFarmRisk` consumes `revisedLocation.address.county`
// directly when defaulting newly-added FO1/FO2/FO3/FO6Structures risks, and
// passing `null` for county short-circuits the mine-subsidence lookup and
// defaults `coverageMS=false` in non-exempt counties. Omitting these fields
// instead lets the backend's deepmerge filter fall back to the saved value.
// (GitHub issue #31118)
export const stripNullishOptionalAddressFields = (address) => {
  if (!address) {
    return;
  }
  for (const key of ['county', 'address2', 'unit', 'country']) {
    if (address[key] === null || address[key] === '') {
      delete address[key];
    }
  }
};
